<template>

  <div class="container">
    
    <router-view />
  </div>

</template>

<script>
export default {
  methods: {
  }
}
</script>

<style scoped lang="less">
.container{
  width: 100%;
  height: 100%;
  position: relative;
  
}
</style>
